import {showSuccessNotification} from "../../global/notifications";

const _$maintenanceGrid = $('.js-ssr-new-maintenance-grid');
const _is_gsm = $('#NewMaintenancePlanModal').length > 0;
let _k_maintenanceGrid;
let _month;
let _year;
let _salespersonId;
let _company;

export default function (company, month, year, salespersonId) {
    _month = month;
    _year = year;
    _salespersonId = salespersonId;
    _company = company;
    let data = {
        month: _month,
        year: _year,
        company: _company,
        salespersonId: _salespersonId
    }

    loadMaintenancePlan(data);
}

function loadMaintenancePlan(data) {
    $('.js-ssr-commissions-new-maintenance').load('/Finance/NewMaintenancePlan', data, function () {
        if (_k_maintenanceGrid) {
            readGrid();
        } else {
            initializeGrid();
        }

        const $commentWindow = $('[name="commissionComments"]');
        $commentWindow.kendoWindow({
            actions: ["Close"],
            modal: true,
            scrollable: true,
            position: {top: 100, left: 100},
            visible: false
        });
    });
}

function readGrid() {
    _k_maintenanceGrid.dataSource.read();
}

function initializeGrid() {
    let columns = [
        {
            field: 'PaymentType', title: 'Payment Type', attributes: {class: ''},
            template: function (data) {
                switch (data.PaymentType) {
                    case 0 : {
                        return 'Regular Commission';
                    }
                    case 1: {
                        return 'Regular Commission';
                    }
                    case 2: {
                        return 'Stretch Commission';
                    }
                    case 3: {
                        return 'Retro-Stretch Commission';
                    }
                    default : {
                        return 'Regular Commission';
                    }
                }
            },
            width: 140
        },
        {
            field: 'Number',
            title: 'Agreement ID - Description',
            attributes: {class: ''},
            template: function (data) {
                return `<span>${data.Number} - ${data.Description}</span>`;
            }
        },
        {
            field: 'IsMultiYear', title: 'Multi-Year', attributes: {class: ''},
            template: function (data) {
                return `${data.IsMultiYear ? 'Y' : 'N'}`;
            },
            width: 120
        },
        {
            field: 'SplitPercent', title: 'Split Percent', attributes: {class: ''}, format: '{0:P2}',
            width: 130
        },
        {
            field: 'AnnualizedPrice', title: 'Annualized Contract Value', attributes: {class: ''}, format: '{0:C2}',
            width: 130
        },
        {
            field: 'CommissionPercent', title: 'Commission Percent', attributes: {class: ''},
            template(data) {
                let commissionPercent = kendo.format('{0:P2}', data.CommissionPercent);
                if (_is_gsm) {
                    return `<span data-kendoWindow="NewMaintenancePlanModal" data-role="openKendoWindow" data-agreement-number="${data.Number}" data-month="${_month}" data-year="${_year}" data-company="${_company}" data-salesperson="${_salespersonId}">${commissionPercent}</span>`
                }
                return commissionPercent;
            },
            width: 180
        },
        {
            field: 'CommissionAmountDue', title: 'Commission Amount Due', attributes: {class: ''}, format: '{0:C2}',
            template(data) {
                return kendo.format('{0:C2}', data.RegularCommissionAmount);
            },
            width: 210
        },
        {
            field: 'entryId', hidden: true, menu: false, attributes: {class: 'attID'}
        },
        {
            width: '45px',
            template(dataItem) {
                const title = `${dataItem.Number} - ${dataItem.Description} Commission Comments`;
                return `<span class="icon ${dataItem.HasComments ? 'icon--comment-has' : 'icon--comment-add'}" data-role="openKendoWindow" data-kendoWindow="commissionComments" data-type="NewMaintAgreement" data-number="${dataItem.Number}" data-year="${dataItem.Year}" data-month="${dataItem.Month}" data-salesperson-id="${dataItem.SalespersonId}" data-company="${dataItem.Company}" data-title="${title}"`;
            }
        }
    ];

    _k_maintenanceGrid = _$maintenanceGrid.kendoGrid({
        /*mobile: "phone",*/
        resizable: true, columns: columns, dataSource: {
            autoSync: true, schema: {
                model: {
                    id: 'id', fields: {
                        Year: {editable: false, type: 'int'},
                        Month: {editable: false, type: 'int'},
                        Company: {editable: false, type: 'int'},
                        SalespersonId: {editable: false, type: 'int'},
                        PaymentType: {editable: false, type: 'int'},
                        Number: {editable: false, type: 'string'},
                        Description: {editable: false, type: 'string'},
                        Price: {editable: false, type: 'number'},
                        Duration: {editable: false, type: 'int'},
                        AnnualizedPrice: {editable: false, type: 'number'},
                        IsMultiYear: {editable: false, type: 'boolean'},
                        SplitPercent: {editable: false, type: 'number'},
                        CommissionPercent: {editable: false, type: 'number'},
                        RegularCommissionAmount: {editable: false, type: 'number'},
                        StretchCommissionAmount: {editable: false, type: 'number'},
                        HasComments: {type: 'boolean', editable: false, default: false}
                    }
                }
            }, transport: {
                read: {
                    url: '/Finance/GetMaintenancePlanData', type: 'GET', dataType: 'json'
                },
                update: {
                    url: '/Finance/UpdateManualEntry', type: 'POST', dataType: 'json'
                },
                destroy: {
                    url: '/Finance/DeleteManualEntry', type: 'POST', dataType: 'json'
                }, parameterMap: function (data, type) {
                    let rs = {};
                    if (type === 'read') {
                        rs['month'] = _month
                        rs['year'] = _year
                        rs['company'] = _company
                        rs['salespersonId'] = _salespersonId
                        return rs;
                    }
                    if (type === 'update') {
                        rs["entryId"] = data.entryId;
                        rs["description"] = data.description;
                        rs["commissionAmount"] = data.commissionAmount.toString();
                    }
                    if (type === 'destroy') {
                        rs["entryId"] = data.entryId;
                    }
                    return rs;
                }
            }
        }, dataBound: function (arg) {
            setMaintenanceQuota(arg.sender._data);
            setWindowData();
            $.event.trigger('on:PageUpdate');
        }, mobile: true, scrollable: true, sortable: {
            mode: 'multiple'
        }, filterable: true, editable: false, columnMenu: true,
        noRecords: {
            template: "There are no new maintenance agreements"
        }
    }).data('kendoGrid');
}

function setMaintenanceQuota(data) {
    let agreementTotal = 0;
    $.each(data, function (index, agreement) {
        agreementTotal += Number(agreement.Price);
    });
    $('[name=AgreementTotal]').val(agreementTotal)
    $('.js-agreement-amount').text(kendo.format('{0:C2}', agreementTotal))
}

/*Comment Window*/
const setupCommentSave = function (e) {
    const $commentWindow = $('[name="commissionComments"]');
    const $form = $(this).parents('form');
    let data = {
        Month : $commentWindow.data('month'),
        Year : $commentWindow.data('year'),
        company : $commentWindow.data('company'),
        SalespersonId : $commentWindow.data('salesperson-id'),
        Number : $commentWindow.data('number'),
        comment : $form.find('[name=comment]').val()
    }
    $.post({
        url: `/Finance/NewMaintAgreementSaveComment`,
        data,
        success(r) {
            if (r) {
                // const $commentWindow = $('[name="commissionComments"]');
                $commentWindow.data('kendoWindow').close();
                that.closest('form').find('textarea').val('');
                showSuccessNotification('Comment added.');
            }
        }
    });
}

const setWindowData = function () {
    const $cells = $('td [data-kendoWindow]');
    const $commentWindow = $('[name="commissionComments"]');
    if ($cells.length) {
        // Unbind click events to prevent duplicate running
        $cells.unbind('click');
        // Attach Event to add Window information;
        $cells.on('click', function () {
            const $self = $(this);
            const title = $self.data('title');
            if ($commentWindow.length) {
                $commentWindow.data('read-only', title);
                $commentWindow.data('kendoWindow').bind('activate', function () {
                    const btns = $('button.saveComment');
                    btns.unbind('click');
                    btns.click(setupCommentSave);
                });
            }
        });
        // ReRun Kendo information
        $(document).trigger('on:PageUpdate');
    }
}